import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { capitalize } from 'utils/helpers';
import { Alert, AlertColor } from '@mui/material';
import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type AlertAdviceProps = {
  show: boolean,
  icon?: IconProp,
  message?: string
  severity?: AlertColor,
  onClose?: () => void,
  children?: ReactNode
}

export const AlertAdvice: FC<AlertAdviceProps> = ({
  show,
  message,
  onClose,
  icon = 'exclamation-circle',
  severity = 'error',
  children
}) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <Alert icon={<FontAwesomeIcon icon={icon} />} severity={severity} onClose={onClose} style={{ alignItems: "center" }}>
      {capitalize(message ?? t('common:unexpected-error'))}
      {children && children}
    </Alert>
  );
};
